module.exports = __webpack_public_path__ + "img/logB1T.713e74e2.png";